import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function ProductReveal() {
  return <section className="bg-gradient-to-b from-slate-900 to-slate-800 py-24 px-4 text-center relative overflow-hidden" data-id="element-102">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10" data-id="element-103"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-104">
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-amber-400 font-medium tracking-widest uppercase mb-4" data-id="element-105">
          Presentamos
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        type: 'spring'
      }} className="text-5xl md:text-7xl font-bold text-amber-50 mb-8 drop-shadow-lg font-serif" data-id="element-106">
          Duerme Profundo Hoy
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="max-w-2xl mx-auto" data-id="element-107">
          <div className="flex justify-center gap-1 mb-6" data-id="element-108">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 text-amber-400 fill-amber-400" data-id="element-109" />)}
          </div>

          <p className="text-xl md:text-2xl text-slate-200 leading-relaxed font-light" data-id="element-110">
            No es solo un libro. Es un{' '}
            <span className="text-amber-300 font-medium" data-id="element-111">mapa de rescate</span>{' '}
            para tus noches. Es el primer método diseñado específicamente para
            la mujer latina en Estados Unidos que quiere recuperar su vida a
            través del sueño natural.
          </p>
        </motion.div>
      </div>
    </section>;
}